    export * from './metamask';
    export * from './coinbase';
    
    //Needs to be moved to a spearate file, is used in crypto login status too
    export const pad = (n) => n < 10 ? `0${n}` : n;

    //Needs to be moved to a spearate file, is used in crypto login status too
    export const formatSeconds = (secs) => {
        const pad = (n) => n < 10 ? `0${n}` : n;
    
        const h = Math.floor(secs / 3600);
        const m = Math.floor(secs / 60) - (h * 60);
        const s = Math.floor(secs - h * 3600 - m * 60);
    
        return `${pad(h)}:${pad(m)}:${pad(s)}`;
    }

    export const toCamelCase = (str) => {
        // note: this is remobing spaces between words as well
        return str.replace(/[-_]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''));
    }

    export const allocateGhostFeesPayment = (transactions, payment) => {
        if(!Array.isArray(transactions) || typeof payment !== 'number' || payment <= 0 ) {
            throw new Error('Invalid input');
        }
        
        // format and assign default values where needed
        const formattedTransactions = transactions.map((txn) => {
            const ghost_fee_punkypay = txn.ghost_fee_punkypay ?? 0;
            const ghost_fee_punkypay_balance = typeof txn.ghost_fee_punkypay_balance === 'number' ? 
                txn.ghost_fee_punkypay_balance : ghost_fee_punkypay;
            const ghost_fee_punkypay_payment_status = txn.ghost_fee_punkypay_payment_status ?? 'no';
            const created_at = txn.created_at ? new Date(txn.created_at) : new Date();

            return {
                ...txn,
                ghost_fee_punkypay,
                ghost_fee_punkypay_balance,
                ghost_fee_punkypay_payment_status,
                created_at,
            }
        });

        // Sorting
        const sortedTransactions = formattedTransactions.sort((a, b) => {
            const order = { partial: 1, no: 2, yes: 3 };
            const statusDiff = (order[a.ghost_fee_punkypay_payment_status] || 4) - (order[b.ghost_fee_punkypay_payment_status] || 4);

            if(statusDiff !== 0) return statusDiff;

            return new Date(a.created_at) - new Date(b.created_at);
        });

        // Payment allocation
        let remainingPayment = payment;
        const affectedTransactions = [];

        for (const txn of sortedTransactions){
            if (remainingPayment <= 0) break;

            if(txn.ghost_fee_punkypay_payment_status === 'yes' || txn.ghost_fee_punkypay_balance <= 0) continue;

            if(remainingPayment >= txn.ghost_fee_punkypay_balance) {
                // Fully paid transaction
                remainingPayment -= txn.ghost_fee_punkypay_balance;
                txn.ghost_fee_punkypay_balance = 0;
                txn.ghost_fee_punkypay_payment_status = 'yes';
                affectedTransactions.push(txn);
            } else {
                // Partially paid transaction
                txn.ghost_fee_punkypay_balance -= remainingPayment;
                txn.ghost_fee_punkypay_balance = +txn.ghost_fee_punkypay_balance.toFixed(6);
                txn.ghost_fee_punkypay_payment_status = 'partial';
                remainingPayment = 0;
                affectedTransactions.push(txn);
            }
        }
        
        return affectedTransactions;
}
